export const pricing = {
  heading: 'Simple pricing that grows with you',
  description:
    "Start free with everything you need. Upgrade when your sales tell you it's time.",
  tabs: ['Monthly'],
};

export const plans = [
  {
    isRecommended: false,
    isPopular: false,
    name: 'Starter',
    description: 'Everything you need to start selling smarter through DMs.',
    amount: 0,
    features: [
      'Omni-channel inbox (WhatsApp, IG, Messenger)',
      'Mini-store builder (sellyt.shop)',
      'Auto-payment confirmation',
      'Product categories NEW',
      '50 product uploads',
      '2 images per product',
      '10 AI conversations/mo NEW',
      'AI chatbot support',
      'Community support',
    ],
  },
  {
    isRecommended: true,
    isPopular: false,
    name: 'Growth',
    description: 'Your subscription replaces the fee. Sell more, keep more.',
    amount: 7500,
    features: [
      'Everything in Starter, plus:',
      '100 product uploads',
      '5 images per product',
      'Bulk product upload NEW',
      '100 AI conversations/mo',
      'Weekly analytics',
      'Image background removal COMING SOON',
      'Seller Mate COMING SOON',
      'Priority support',
    ],
  },
  {
    isRecommended: false,
    isPopular: true,
    name: 'Pro',
    description: 'Advanced tools for vendors ready to scale seriously.',
    amount: 15000,
    features: [
      'Everything in Growth, plus:',
      '500 product uploads',
      '10 images per product',
      '500 AI conversations/mo',
      'Advanced analytics',
      'Lead management (capture, score, follow-ups)',
      'Custom domain (paid add-on)',
    ],
  },
  {
    isRecommended: false,
    isPopular: false,
    name: 'Scale',
    description:
      'Zero limits. Built for high-volume vendors who want every edge.',
    amount: 25000,
    features: [
      'Everything in Pro, plus:',
      'Unlimited product uploads',
      'Unlimited images per product',
      'Unlimited AI conversations',
      'Staff accounts COMING SOON',
      'API access COMING SOON',
    ],
  },
];

export const sampleFeatures = [
  'Omni-channel inbox (WhatsApp, IG, Messenger)',
  'Mini-store builder (sellyt.shop)',
  'Auto-payment confirmation',
  'Product categories NEW',
  '50 product uploads',
  '2 images per product',
  '10 AI conversations/mo NEW',
];

export const themes = [
  { value: 'light', label: 'Light Mode' },
  { value: 'dark', label: 'Dark Mode' },
  { value: 'system', label: 'System' },
] as const;

export const timezones = [
  { value: 'Pacific/Midway', label: 'GMT -11:00 (Midway Island, Samoa)' },
  { value: 'Pacific/Honolulu', label: 'GMT -10:00 (Hawaii)' },
  { value: 'America/Anchorage', label: 'GMT -09:00 (Alaska)' },
  { value: 'America/Los_Angeles', label: 'GMT -08:00 (Pacific Time)' },
  { value: 'America/Denver', label: 'GMT -07:00 (Mountain Time)' },
  { value: 'America/Chicago', label: 'GMT -06:00 (Central Time)' },
  { value: 'America/New_York', label: 'GMT -05:00 (Eastern Time)' },
  { value: 'America/Halifax', label: 'GMT -04:00 (Atlantic Time)' },
  {
    value: 'America/Argentina/Buenos_Aires',
    label: 'GMT -03:00 (Buenos Aires)',
  },
  { value: 'Atlantic/Azores', label: 'GMT -01:00 (Azores)' },
  { value: 'UTC', label: 'GMT +00:00 (UTC)' },
  { value: 'Europe/London', label: 'GMT +00:00 (London, Dublin)' },
  { value: 'Europe/Paris', label: 'GMT +01:00 (Paris, Berlin)' },
  { value: 'Africa/Cairo', label: 'GMT +02:00 (Cairo, Athens)' },
  { value: 'Europe/Moscow', label: 'GMT +03:00 (Moscow, Nairobi)' },
  { value: 'Asia/Dubai', label: 'GMT +04:00 (Dubai)' },
  { value: 'Asia/Karachi', label: 'GMT +05:00 (Islamabad, Karachi)' },
  { value: 'Asia/Kolkata', label: 'GMT +05:30 (Mumbai, New Delhi)' },
  { value: 'Asia/Dhaka', label: 'GMT +06:00 (Dhaka)' },
  { value: 'Asia/Bangkok', label: 'GMT +07:00 (Bangkok, Jakarta)' },
  { value: 'Asia/Singapore', label: 'GMT +08:00 (Singapore, Hong Kong)' },
  { value: 'Asia/Tokyo', label: 'GMT +09:00 (Tokyo, Seoul)' },
  { value: 'Australia/Sydney', label: 'GMT +10:00 (Sydney)' },
  { value: 'Pacific/Guadalcanal', label: 'GMT +11:00 (Solomon Islands)' },
  { value: 'Pacific/Auckland', label: 'GMT +12:00 (Auckland)' },
] as const;

export const dateFormats = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
  { value: 'DD MMM YYYY', label: 'DD MMM YYYY' },
  { value: 'MMM DD, YYYY', label: 'MMM DD, YYYY' },
] as const;
